import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
     showMobileNav: false
  },
  getters: {
  },
  mutations: {
    setMobileNavVisibility(state, obj) {
      state.showMobileNav = obj;
    }
  },
  actions: {},
  modules: {}
});
